interface FormFieldInterface {
  value: string;
  dirty: boolean;
  validate: () => string[] | null;
}

export default class FormField implements FormFieldInterface {
  public value: string
  public dirty = false
  public serverError: string | null = null
  public validate: () => string[] | null

  constructor (validate: (value: string) => string[], value: string) {
    this.validate = () => {
      let result: string[] | null = null
      if (this.dirty) { // Only validate if field is dirty, else return null
        result = validate(this.value) // Check for client errors
      }
      return result
    }
    this.value = value
  }

  public resetField () {
    this.value = ''
    this.dirty = false
    this.serverError = null
  }
}
